<div id="home-container" class="home relative h-full">
  <cryptoform1 *ngIf="showCryptoForm1" #cryptoform1></cryptoform1>
  <cryptohero1 *ngIf="showCryptoHero1" #cryptohero1></cryptohero1>
  <cryptoform2 *ngIf="showCryptoForm2" #cryptohero2></cryptoform2>
  <div class="section-2 py-12 pb-28 md:py-36">
    <div class="container">
      <img src="/assets/images/sep.svg" loading="lazy" alt="" class="image-separator">
      <div class="relative max-w-7xl mx-auto flex items-center justify-between px-2 sm:px-3">
        <div class="lg:grid w-full lg:grid-cols-12 lg:gap-4">
          <div class="md:px-6 py-0 md:py-36 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-start">
            <div>
              <h2 class="heading" i18n="@@buy_crypto">Buy crypto</h2>
              <div class="typed-title flex flex-row w-full flex-nowrap">
                <div #typedText class="typed bg-clip-text bg-gradient-to-r from-rose-500 to-rose-900"></div>
                <div class="cursor text-rose-900 animate-flicker">|</div>
              </div>
              <p class="paragraph" i18n>
                No sign-ups. Just buy crypto in less than 5 minutes by following a few simple steps. Start investing in actives of the future and be part of the crypto community.
              </p>
              <div class="flex flex-shrink-0">
                <a href="javascript:void(null)" (click)="scrollToTop()" class="btn-2">
                  <div class="text-xl font-bold" i18n="@@start">Start</div>
                  <div class="pl-2 font-bold text-xl"><strong class="icon-container"></strong></div>
                </a>
              </div>
            </div>
          </div>
          <div class="sm:m-24 md:m-16 lg:m-0 lg:col-span-6 p-2 flex lg:items-center grid md:flex">
            <div class="mt-2 sm:mt-0 w-full">
              <div >
                <div class="monster-section-2">
                  <div class="monster-video-2 glightbox"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="section-3">
    <div class="container-section-3 relative max-w-7xl mx-auto flex items-center justify-between px-2 sm:px-3">
      <div class="w-full lg:grid flex flex-col md:flex-row lg:grid-cols-12 lg:gap-4">
        <!-- highlighted crypto -->
        <div class="md:order-first order-last px-3 sm:px-6 sm:text-center lg:col-span-6  lg:text-left lg:flex lg:items-start">
          <a routerLink="/cryptos/{{purchaseFlowHelperService.selectedCrypto | lowercase}}">
          <div class="grid-wrapper card_rocket">
            <div class="w-full monster-container-section-3">
              <img src="/assets/images/rocket-01-2.svg" loading="lazy" width="767" alt="Rocket with a happy monster inside" class="monster-section-3 hidden md:block">
              <div class="monster-section-3"></div>
              <h2 class="heading-3 from_section3">{{purchaseFlowHelperService.selectedCrypto | cryptosymbol2name | async}}</h2>
              <stock-rate [style]="1" [baseCurrency]="purchaseFlowHelperService.selectedCrypto" [quoteCurrency]="purchaseFlowHelperService.selectedCurrency"></stock-rate>
              <div class="price-large from_section3"><exchange-price [useCompactNotation]="true" [baseCurrency]="purchaseFlowHelperService.selectedCrypto" [quoteCurrency]="purchaseFlowHelperService.selectedCurrency"></exchange-price></div>
              <div class="big-chart-container">
              <img src="{{imageBaseUrl}}/charts/1/2/{{purchaseFlowHelperService.selectedCrypto}}/{{purchaseFlowHelperService.selectedCurrency | currency2stablecoin}}.svg?stroke=2&width=241&height=81&color=e8e4ff" loading="lazy">
              </div>
            </div>
          </div>
          </a>
        </div>
        <!-- section copy -->
        <div class="pt-24 md:pt-2 sm:m-24 md:m-16 lg:m-0 lg:col-span-6 p-4 flex lg:items-center grid md:flex">
          <div class="md:pl-14 mt-2 sm:mt-0 w-full">
            <div>
              <div class="flex flex-shrink-0">
                <div class="flair_small from_section3" i18n>Our offer</div>
              </div>
              <h2 class="heading" i18n>Enter the</h2>
              <h2 class="heading-second-line" i18n>cryptoverse</h2>

              <div class="div-block-32">
                <div class="div-block-33">
                  <div class="div-block-34"><strong></strong></div>
                  <div class="text-block-41" i18n>Really low commissions</div>
                </div>
                <div class="div-block-33">
                  <div class="div-block-34"><strong></strong></div>
                  <div class="text-block-41" i18n>Top level security</div>
                </div>
                <div class="div-block-33">
                  <div class="div-block-34"><strong></strong></div>
                  <div class="text-block-41" i18n>Faithful to Blockchain</div>
                </div>
                <div class="div-block-33">
                  <div class="div-block-34"><strong></strong></div>
                  <div class="text-block-41" i18n>So easy to use</div>
                </div>
              </div>
              <div class="featured_buttons">
                <a href="javascript:void(null)" (click)="buy()" class="btn-cryptoverse w-inline-block cursor-pointer">
                  <div class="text" i18n="@@buy">Buy</div>
                  <div class="arrow_1"><strong class="icon"></strong></div>
                </a>
                <a href="javascript:void(null)" (click)="sell()" class="btn-cryptoverse w-inline-block cursor-pointer">
                  <div class="text" i18n="@@sell">Sell</div>
                  <div class="arrow_2"><strong class="icon"></strong></div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #cryptosummaryboxes>
      <cryptosummarybox *ngFor="let product of products" [exchangePrice]="exchangeService.getExchangePrice(product.id, purchaseFlowHelperService.selectedCurrency)"></cryptosummarybox>
    </ng-template>
    <div class="pt-14">
      <div id="marquee-right" class="div-block-40">
        <ng-container *ngTemplateOutlet="cryptosummaryboxes"></ng-container>
      </div>
      <div id="marquee-left" class="div-block-40">
        <ng-container *ngTemplateOutlet="cryptosummaryboxes"></ng-container>
      </div>
    </div>
  </div>
  <div class="section-how-it-works">
    <div class="container_howitworks">
      <div class="flair_small" i18n>How does it works?</div>
      <h2 class="heading" i18n>Easier than ever!</h2>
    </div>
    <div #containerDesktopPhone class="container_desktop_phone">
      <div #containerPhone class="container_phone"></div>
    </div>
    <div data-current="Tab 1" data-easing="ease-in-out" data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
      <div class="tabs-menu-2 w-tab-menu">
        <a (click)="showHowItWorksSection(1)" class="howitworks_tabs w-inline-block w-tab-link w--current cursor-pointer">
          <div class="div-block-65"></div>
          <div i18n="@@buy">Buy</div>
        </a>
        <a (click)="showHowItWorksSection(2)" class="howitworks_tabs w-inline-block w-tab-link cursor-pointer">
          <div class="div-block-66"></div>
          <div i18n="@@sell">Sell</div>
        </a>
      </div>
      <div class="tabs-content-2 w-tab-content">
        <div *ngIf="howItWorksVisibleSection == 1" data-w-tab="Tab 1" class="w-tab-pane w--tab-active">
          <div class="step">
            <div class="div-block-70"><img width="233" src="/assets/images/steps_icons-01.svg" loading="lazy" alt="Picture of a happy monster selecting a crypto in a phone" class="image-25"></div>
            <div class="div-block-68">
              <div class="flair_small" i18n="@@step1">Step 1</div>
              <div class="steps_title" i18n>Select a Crypto</div>
              <div class="steps_text" i18n>Choose the crypto that you want to buy to and how much money do you want to invest to.</div>
            </div>
          </div>
          <div class="step">
            <div class="div-block-70"><img width="258" id="w-node-_2d5ad139-8d59-3961-3bd1-115dd75eea4a-798af29b" src="/assets/images/steps_icons-02.svg" loading="lazy" alt="A wallet address being introduced in the form"></div>
            <div class="div-block-68">
              <div class="flair_small" i18n="@@step2">Step 2</div>
              <div class="steps_title" i18n>Enter your Wallet Address</div>
              <div class="steps_text" i18n>If you don't have a Wallet, don't panic! We will create a Wallet for your for free.</div>
            </div>
          </div>
          <div class="step">
            <div class="div-block-70"><img width="248" id="w-node-_0ff790d0-4bdb-8d43-b98d-668dea9e7ee0-798af29b" src="/assets/images/steps_icons-03.svg" loading="lazy" alt="Identify of a happy monster being verified" class="image-26"></div>
            <div class="div-block-68">
              <div class="flair_small" i18n="@@step3">Step 3</div>
              <div class="steps_title" i18n>Verify your Identity</div>
              <div class="steps_text" i18n>In order to avoid fraud and money laundering, we need to verify your identity. We will ask you for a selfie and a picture of your ID.</div>
            </div>
          </div>
          <div class="step">
            <div class="div-block-70"><img width="241" src="/assets/images/steps_icons-04.svg" loading="lazy" alt="A happy monster paying using a phone with a credit card"></div>
            <div class="div-block-68">
              <div class="flair_small" i18n="@@step4">Step 4</div>
              <div class="steps_title" i18n>Pay with your credit card</div>
              <div class="steps_text" i18n>Just indicate your payment details, confirm the order and get your crypto instantly.</div>
            </div>
          </div>
        </div>
        <div *ngIf="howItWorksVisibleSection == 2" data-w-tab="Tab 2" class="w-tab-pane">
          <div class="step">
            <div class="div-block-70"><img width="241" src="/assets/images/steps_icons-04.svg" loading="lazy" alt="A happy monster paying using a phone with a credit card"></div>
            <div class="div-block-68">
              <div class="flair_small" i18n>Coming Soon</div>
              <div class="steps_title" i18n>Sell Cryptocurrencies</div>
              <div class="steps_text" i18n>You will be able to sell your cryptocurrencies in AhoraCrypto and get fiat money in your bank account really soon.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="pb-16 pt-16 w-full border-t border-gray-100 blog-highlights bg-gradient-to-b from-indigo-100/20">
  <div class="mx-auto max-w-7xl px-6 lg:pl-12 lg:pr-12 relative isolate overflow-hidden">
    <div class="mx-auto max-w-2xl text-center blog-header">
      <h2 class="heading" i18n>Learn About Crypto</h2>
      <p class="mt-2 text-lg leading-8 text-gray-600" i18n>Expand Your Knowledge About the Crypto Ecosystem</p>
    </div>
    <div class="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">

      <div *ngFor="let article of highlightArticles" class="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80">
        <img src="{{article.mainPictureUrl}}" alt="" class="absolute inset-0 -z-10 h-full w-full object-cover">
        <div class="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <div class="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>

        <div class="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm leading-6 text-gray-300">
          <time datetime="2020-03-16" class="mr-8">{{ article.published | date }}</time>
          <div class="-ml-4 flex items-center gap-x-4">
            <svg viewBox="0 0 2 2" class="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
              <circle cx="1" cy="1" r="1" />
            </svg>
            <div class="flex gap-x-2.5">
              <img src="https://soloprogramadores.s3.eu-west-3.amazonaws.com/2023/04/Antonio_Parraga_caricature_but_with_same_red_tshirt_as_in_the_p_0802f3f7-1658-4af0-8bb9-0bbb962bd337-1-1.png" alt="" class="h-6 w-6 flex-none rounded-full bg-white/10">
              Antonio Párraga
            </div>
          </div>
        </div>
        <h3 class="mt-3 text-lg font-semibold leading-6 text-white">
          <a routerLink="/resources/{{ article.code }}">
            <span class="absolute inset-0"></span>
            {{ article.name }}
          </a>
        </h3>
      </div>
    </div>
  </div>
  <div class="grid justify-items-center w-full pt-8">
    <div>
      <a routerLink="/resources/" class="btn-2">
        <div class="text-xl font-bold" i18n>See all</div>
        <div class=" pl-2 font-bold text-xl"><strong class="icon-container"></strong></div>
      </a>
    </div>
  </div>
</div>

<div class="home relative h-full">
  <div id="security" class="section-security wf-section">
    <div class="container_security">
      <div class="div-block-64">
        <div class="flair" i18n="@@security">Security</div>
        <div class="grid-wrapper">
          <h2 class="heading security" i18n>Your cryptos are yours</h2>
          <div class="div-block-42">
            <div class="div-block-43">
              <div class="div-block-45">
                <div class="div-block-44"><strong class="bold-text-4"></strong></div>
                <div class="text-block-44"><strong></strong></div>
              </div>
              <div class="section_security_text" i18n>We DON'T store your keys. You are the only owner of your money.</div>
            </div>
            <div class="div-block-43">
              <div class="div-block-45">
                <div class="div-block-44"><strong class="bold-text-4"></strong></div>
                <div class="text-block-44"><strong></strong></div>
              </div>
              <div class="section_security_text" i18n>Trusty to the Blockchain essence. Transactions are real.</div>
            </div>
            <div class="div-block-43">
              <div class="div-block-45">
                <div class="div-block-44"><strong class="bold-text-4"></strong></div>
                <div class="text-block-44"><strong></strong></div>
              </div>
              <div class="section_security_text" i18n>AhoraCrypto has been registered in Bank of Spain with number <a href="https://www.bde.es/bde/en/secciones/servicios/Particulares_y_e/registro-de-proveedores-de-servicios-de-cambio-de-moneda-virtual-por-moneda-fiduciaria-y-de-custodia-de-monederos-electronicos/registro-de-proveedores-de-servicios-de-cambio-de-moneda-virtual-por-moneda-fiduciaria-y-de-custodia-de-monederos-electronicos.html" target="_blank">D803</a>.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="div-block-64_right"><img src="/assets/images/security_shield-02.svg" loading="lazy" alt="Happy monsters saying hello around a big golden shield" class="image-20"></div>
    </div>
  </div>
  <div id="faq" class="section-faq wf-section">
    <div class="container">
      <h2 class="heading-4" i18n="@@frequently_asked_questions">Frequently Asked Questions</h2>
      <div class="relative max-w-7xl mx-auto flex items-center justify-between md:px-3">
        <div id="accordion-open" data-accordion="open" data-active-classes="bg-white" data-inactive-classes="bg-white" class="lg:grid lg:grid-cols-12 lg:gap-4">
        <div class="md:px-6 grid grid-flow-row auto-rows-max sm:text-center lg:col-span-6 lg:text-left">
          <div class="faq-wrapper w-full">
            <div class="faq-ques" id="home-accordion-open-heading-1" data-accordion-target="#home-accordion-open-body-1" aria-expanded="true" aria-controls="home-accordion-open-body-1">
              <div class="div-block-46 faq_fees"></div>
              <div class="text-block-45" i18n>What commision do you take?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-1" aria-labelledby="home-accordion-open-heading-1" class="paragraph-4" i18n><br>We charge just 0.95% on transactions. You have to take into account that blockchain network also add a comission (depending on each crypto) and, in case you pay with credit card, the payment comision could be between 1% and 3%.<br>‍</p>
          </div>
          <div class="faq-wrapper w-full">
            <div class="faq-ques" id="home-accordion-open-heading-2" data-accordion-target="#home-accordion-open-body-2" aria-expanded="false" aria-controls="home-accordion-open-body-2">
              <div class="div-block-46 faq_long"></div>
              <div class="text-block-45" i18n>How long does it take transactions to process?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-2" aria-labelledby="home-accordion-open-heading-2" class="paragraph-4 hidden" i18n><br>Time taken by transaction is practically inmediate. However, it depends on the blockchain network. For example, Bitcoin transactions can take up to 1 hour to be confirmed. Ethereum transactions can take up to 15 minutes.<br>‍</p>
          </div>
          <div class="faq-wrapper w-full" id="home-accordion-open-heading-3" data-accordion-target="#home-accordion-open-body-3" aria-expanded="false" aria-controls="home-accordion-open-body-3">
            <div class="faq-ques">
              <div class="div-block-46 faq_offer"></div>
              <div class="text-block-45" i18n>How many crypto do you offer?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-3" aria-labelledby="home-accordion-open-heading-3" class="paragraph-4 hidden" i18n><br>Currently we are offering Bitcoin, Ethereum, Polkadot, Cardano, Solana, Dogecoin, Ripple, Stellar among others. We are working on adding more cryptocurrencies. If you have any suggestion, please contact us.<br>‍</p>
          </div>
        </div>
        <div class="md:px-6 grid grid-flow-row auto-rows-max sm:text-center lg:col-span-6 lg:text-left">
          <div class="faq-wrapper w-full">
            <div class="faq-ques" id="home-accordion-open-heading-4" data-accordion-target="#home-accordion-open-body-4" aria-expanded="false" aria-controls="home-accordion-open-body-4">
              <div class="div-block-46 faq_support"></div>
              <div class="text-block-45" i18n>Do you have customer support?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-4" aria-labelledby="home-accordion-open-heading-4" class="paragraph-4 hidden" i18n><br>Of course we have! We are available 24/7 to help you through our chat, email, phone or social media. Support is available in both English and Spanish.<br>‍</p>
          </div>
          <div class="faq-wrapper w-full">
            <div class="faq-ques" id="home-accordion-open-heading-5" data-accordion-target="#home-accordion-open-body-5" aria-expanded="false" aria-controls="home-accordion-open-body-5">
              <div class="div-block-46 faq_safe"></div>
              <div class="text-block-45" i18n>Is AhoraCrypto really secure?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-5" aria-labelledby="home-accordion-open-heading-5" class="paragraph-4 hidden" i18n><br>We have many different security measures in place to protect your funds. We use 2FA, SSL encryption, cold storage, and more. We also have a dedicated security team that monitors the platform 24/7.<br>‍</p>
          </div>
          <div class="faq-wrapper w-full">
            <div class="faq-ques" id="home-accordion-open-heading-6" data-accordion-target="#home-accordion-open-body-6" aria-expanded="false" aria-controls="home-accordion-open-body-6">
              <div class="div-block-46 faq_learn"></div>
              <div class="text-block-45" i18n>Can I learn more about crypto?</div>
              <div class="arrow-right"><strong></strong></div>
            </div>
            <p id="home-accordion-open-body-6" aria-labelledby="home-accordion-open-heading-6" class="paragraph-4 hidden" i18n><br>You have at your disposal a wide range of resources to learn about crypto. We have <a routerLink="/resources/" class="underlined">a blog with articles about crypto</a>, a <a href="https://www.youtube.com/channel/UCgVQtORjizFRclQFkhCBydg" target="_blank" class="underlined">Youtube channel</a> with videos about crypto, and other groups where you can ask any question you have.<br>‍</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
  <div class="prefooter-copy wf-section">
    <div class="container">
      <div class="relative max-w-7xl mx-auto flex items-center justify-between px-2 sm:px-3">
        <div class="lg:grid lg:grid-cols-12 lg:gap-4">
          <div class="md:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-9 lg:text-left lg:flex lg:items-start">
            <div>
              <h2 class="heading" i18n>The exchange that</h2>
              <div class="typed-title flex flex-row w-full flex-nowrap">
                <div class="typed bg-clip-text bg-gradient-to-r from-rose-500 to-rose-900" i18n>you love!</div>
              </div>
              <p class="paragraph" i18n>
                A secure and easy to use platorm that avoids headaches and slow or even complex learnings. Never was so easy to buy crypto.
              </p>
              <div class="flex flex-shrink-0">
                <a href="javascript:void(null)" (click)="scrollToTop()" fragment="home-container" class="btn-2">
                  <div class="text-xl font-bold" i18n="@@start">Start</div>
                  <div class=" pl-2 font-bold text-xl"><strong class="icon-container"></strong></div>
                </a>
              </div>
            </div>
          </div>
          <div class="sm:m-24 md:m-16 lg:m-0 lg:col-span-3 p-2 flex lg:items-center grid md:flex">
          </div>
        </div>
      </div>
    </div>
    <img src="/assets/images/footer_bg-02.svg" loading="lazy" alt="" class="prefooter-image">
    <div class="footer_image"></div>

  </div>




</div>


